import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import config from '@root/src/config';
import { mediaBreakpoint } from '@services/responsiveProvider';
import { shadowStyle } from '@features/ui/styles/shadowStyles';
import { selectSerieDetail } from '@features/serieDetail/slices/serieDetailServerSlice';

const SerieHeaderBanner = ({ className }: { className?: string }) => {
  const { name, imageCover, logo } = useSelector(selectSerieDetail);

  return (
    <Container className={className}>
      {imageCover && <BannerImage src={config.urlBackendAssets + imageCover} width="100%" />}
      {logo && (
        <ProfileImage>
          <img src={config.urlBackendAssets + logo} alt={`${name} : serie logo`} width="100%" />
        </ProfileImage>
      )}
    </Container>
  );
};

export default SerieHeaderBanner;

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: 500px;

  ${mediaBreakpoint.mobile} {
    margin-bottom: 64px;
  }
`;

const ProfileImage = styled.div`
  position: absolute;
  width: 200px;
  top: 40px;
  left: 40px;
  background: var(--color-white);
  padding: 10px;
  border-radius: 8px;

  ${mediaBreakpoint.tablet} {
    top: 0;
    transform: translateY(-50%);
    right: 20px;
    left: unset;
    width: 110px;
    ${shadowStyle};
  }
  ${mediaBreakpoint.mobile} {
    left: 20px;
    top: unset;
    bottom: 0;
    transform: translateY(0);
  }
`;
